import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ROLE_API } from "./apiRoutes";

// interface UseGetRolesProps {
//   queryParams?: Omit<UseQueryOptions, "queryKey">;
// }

const getRoles = async () => {
  return await axiosAuth.get(`${ROLE_API}`);
};

const useGetRoles = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["roles"],
    queryFn: () => getRoles(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetRoles;
